import React, { useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';
import { DURATION_HINT, formatDurationHuman, formatDurationInput, parseDuration } from './duration.mjs';

export default function DurationField({ value, onChange, required = false, fractional = false, compact = false, error: externalError = false, helperText, ...props }) {
    const [draft, setDraft] = useState(() => formatDurationInput(value));
    const input = useRef(null);
    const limits = { min: fractional ? 0.01 : 1, max: 86400, integer: !fractional };
    const parsed = parseDuration(draft, limits);
    const valid = (!required && draft.trim() === '') || parsed !== null;
    const message = fractional ? 'Enter 0.01 seconds to 24 hours using seconds, m:s or h:m:s.' : 'Enter 1 second to 24 hours using seconds, m:s or h:m:s.';
    useEffect(() => {
        const current = parseDuration(draft, limits);
        if (value == null ? current !== null : current !== Number(value)) setDraft(formatDurationInput(value));
    }, [value]);
    useEffect(() => { input.current?.setCustomValidity(valid ? '' : message); }, [valid, message]);
    const hint = compact ? 's / m:s / h:m:s' : DURATION_HINT;
    return <TextField {...props} type="text" required={required} value={draft} inputRef={input} error={externalError || !valid}
        placeholder={compact ? '30 or 1:30' : '90 / 20:00 / 3:00:00'}
        inputProps={{ title: DURATION_HINT, 'aria-label': props.label }}
        helperText={helperText || (!valid ? message : `${parsed != null && (draft.includes(':') || parsed >= 60) ? formatDurationHuman(parsed) + ' · ' : ''}${hint}`)}
        onChange={(event) => {
            const raw = event.target.value;
            const seconds = parseDuration(raw, limits);
            setDraft(raw);
            event.target.setCustomValidity((!required && !raw.trim()) || seconds !== null ? '' : message);
            onChange(seconds);
        }} />;
}
